import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

// Desenho dos modais do atendimento — o mesmo do NewTicketModal (cabeçalho próprio,
// rótulo acima do campo, ação principal em pílula). Fica aqui para os modais da
// conversa não divergirem entre si; a largura vem por prop: useDialogStyles({ width }).
const useDialogStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    paper: {
      width: ({ width = 440 }) => `min(${width}px, calc(100vw - 32px))`,
      maxWidth: "none",
      margin: 16,
      borderRadius: 12,
    },
    header: {
      padding: "18px 22px 6px",
      flex: "none",
    },
    title: {
      margin: 0,
      fontSize: 19,
      fontWeight: 700,
      lineHeight: "26px",
      letterSpacing: "-0.01em",
      color: theme.palette.text.primary,
    },
    subtitle: {
      margin: "2px 0 0",
      fontSize: 13,
      lineHeight: "18px",
      color: theme.palette.text.secondary,
    },
    content: {
      padding: "12px 22px 6px",
      display: "flex",
      flexDirection: "column",
      gap: 14,
    },
    // para modais curtos, em que a lista do autocomplete não pode ser cortada
    contentVisible: {
      overflowY: "visible",
    },
    field: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0,
    },
    label: {
      fontSize: 12.5,
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    hint: {
      fontSize: 12,
      lineHeight: "17px",
      color: theme.palette.text.secondary,
    },
    placeholder: {
      color: theme.palette.text.disabled,
    },
    // bloco informativo (resumo do que foi escolhido, aviso, resultado)
    infoBox: {
      padding: "10px 12px",
      borderRadius: t.radius.md,
      border: `1px solid ${t.line}`,
      backgroundColor: t.muted,
      fontSize: 13,
      lineHeight: "19px",
      color: t.text,
      minWidth: 0,
    },
    empty: {
      padding: "22px 12px",
      textAlign: "center",
      fontSize: 13,
      color: theme.palette.text.secondary,
    },
    loading: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      padding: "22px 12px",
      fontSize: 13,
      color: theme.palette.text.secondary,
    },
    actions: {
      padding: "12px 22px 18px",
      gap: 6,
      flexWrap: "wrap",
    },
    cancel: {
      textTransform: "none",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    confirm: {
      position: "relative", // âncora do spinner do ButtonWithSpinner
      textTransform: "none",
      fontWeight: 600,
      minWidth: 150,
      borderRadius: 20,
      boxShadow: "none",
      [theme.breakpoints.down("xs")]: {
        minWidth: 0,
      },
    },
    danger: {
      textTransform: "none",
      fontWeight: 600,
      color: t.semantic.error,
    },
  };
});

export default useDialogStyles;
